<div class="d-flex flex-column flex-md-row">
  <div class="d-flex flex-md-column flex-shrink-0 side-bar">
    <div class="nav d-none d-md-flex flex-md-column flex-grow-0 p-md-2 bg-primary-subtle" style="min-height:180px;">
      <h5 class="text-center">Current Car</h5>
      <div class="text-center">
        @if(carTrackSettings.vehicle == null){
        -select car-
        }
        @else{
        <div>{{carTrackSettings.vehicle?.manufacturer}}</div>
        <div>{{carTrackSettings.vehicle?.model}}</div>
        }
      </div>
      <h5 class="text-center mt-3">Settings Name</h5>
      <div class="text-center">
        {{savedSettingsName || 'New'}} {{ (carTrackSettingsForm.dirty || transmissionSettingsForm.dirty || suspensionSettingsForm.dirty) && isUnsaved ? '(Unsaved)*' : '' }}
      </div>
      <hr />
      <button type="button" class="image-analyzer-button btn btn-primary" (click)="openProcessImageModal()"><i class="fa-solid fa-regular fa-image"></i> Image Analyzer</button>
    </div>



    <ul class="nav d-flex flex-md-column flex-grow-1 flex-md-grow-0 p-md-2 p-2 bg-primary-subtle">
      <li class="nav-item flex-grow-1 flex-md-grow-0" [ngClass]="{active: activeTab=='car-track'}">
        <span class="nav-link text-center text-md-start d-block text-decoration-none ps-3 py-md-2 py-3" (click)="activeTab='car-track'">
          <i class="fa-solid fa-car d-md-inline d-block"></i>
          Car/Track
        </span>
      </li>
      <li class="nav-item flex-grow-1 flex-md-grow-0" [ngClass]="{active: activeTab=='suspension'}">
        <span class="nav-link text-center text-md-start d-block text-decoration-none ps-3 py-md-2 py-3" (click)="activeTab='suspension'">
          <i class="fa-solid fa-truck-monster d-md-inline d-block"></i>
          Suspension
        </span>
      </li>
      <li class="nav-item flex-grow-1 flex-md-grow-0" [ngClass]="{active: activeTab=='transmission'}">
        <span class="nav-link text-center text-md-start d-block text-decoration-none ps-3 py-md-2 py-3" (click)="activeTab='transmission'">
          <i class="fa-solid fa-gears d-md-inline d-block"></i>
          Transmission
        </span>
      </li>
    </ul>


    <div class="flex-grow-1 bg-primary-subtle d-none d-md-flex flex-column p-2">
      <p><app-home-tour></app-home-tour></p>
      @if(subscription.subscriptionLevel == 'Trial'){
      <p class="text-warning d-block text-center">
        You are using trial mode.
      </p>
      <p class="text-center">
        <a routerLink="/subscription">Upgrade Now</a>
      </p>
      }
    </div>

  </div>


  @if(subscription.subscriptionLevel == 'Trial'){
  <div class="bg-warning p-2 d-md-none text-white text-center">
    You are using trial mode. &nbsp; <a routerLink="/subscription">Buy Now</a>
  </div>
  }

  <div class="flex-grow-1 overflow-hidden d-md-none bg-primary-subtle p-3" style="height: 100px;">
    <div class="row">
      <div class="col-12">
        <strong>Current Car:</strong>
        @if(carTrackSettings.vehicle == null){
        -select car-
        }
        @else{
        {{carTrackSettings.vehicle?.manufacturer}} {{carTrackSettings.vehicle?.model}}
        }
      </div>
      <div class="col-12">
        <strong>Settings Name:</strong> {{savedSettingsName || 'New'}} {{ (carTrackSettingsForm.dirty || transmissionSettingsForm.dirty || suspensionSettingsForm.dirty) && isUnsaved ? '(Unsaved)*' : '' }}
      </div>
      <button type="button" class="image-analyzer-button-mobile btn btn-primary btn-sm" (click)="openProcessImageModal()"><i class="fa-solid fa-regular fa-image"></i> Image Analyzer</button>
    </div>
  </div>

  <div class="flex-grow-1 overflow-auto calculator-container">
    <div class="col-lg-12 px-4 pt-4">
      <div class="tab-content" id="appTabContainer">
        <div class="tab-pane fade" [ngClass]="{show: activeTab == 'car-track', active: activeTab == 'car-track'}" id="car-track-tab-pane" role="tabpanel" aria-labelledby="car-track-tab-pane" tabindex="0">
          <h2>
            Car/Track Settings
          </h2>
          <div id="carTrackSettings" class="accordion-collapse collapse show" data-bs-parent="#carTrackSettingsAccordion">
            <div class="accordion-body">
              <form #carTrackSettingsForm="ngForm" novalidate>
                <div class="row">
                  <div class="col-12 col-lg-4">
                    <div class="row">
                      <div class="col"><hr /></div>
                      <div class="col-auto">Vehicle Selection</div>
                      <div class="col"><hr /></div>
                    </div>
                    <app-vehicle-selector [(model)]="carTrackSettings.vehicle"></app-vehicle-selector>
                    <div class="form-group row mb-3">
                      <div class="col">
                        <label for="performancePoints" class="form-label">Performance Points</label>
                        <input type="number" class="form-control  w-120px" #performancePoints name="performancePoints" placeholder="PP" [(ngModel)]="carTrackSettings.performancePoints">
                      </div>
                    </div>
                    <div class="form-group row mb-3" [ngClass]="{'invalid': carTrackSettingsFormControl.weight?.errors && carTrackSettingsFormControl.weight?.touched}">
                      <div class="col">
                        <label for="weight" class="form-label">Weight</label>
                        <div class="input-group  w-200px">
                          <input type="number" class="form-control" #weight name="weight" [placeholder]="userPreferences?.weightUnits.display" [(ngModel)]="carTrackSettings.weight" [required]="true">
                          <div class="input-group-text">{{userPreferences?.weightUnits.display}}</div>
                        </div>
                      </div>
                    </div>

                    <app-track-selector [(model)]="carTrackSettings.track"></app-track-selector>

                  </div>
                  <div class="col-12 col-lg-4">

                    <div class="row">
                      <div class="col"><hr /></div>
                      <div class="col-auto">Tires</div>
                      <div class="col"><hr /></div>
                    </div>

                    <div class="form-group row mb-1" [ngClass]="{'invalid': carTrackSettingsFormControl.tireSize?.errors && carTrackSettingsFormControl.tireSize.touched}">
                      <div class="col-12">
                        <label for="tireSize" class="form-label">Tire Size</label>
                        <span class="pointer help-popper"
                              [popoverTitle]="helpText['tireSize'].title"
                              [ngbPopover]="helpText['tireSize'].text">
                          <i class="fa-solid fa-circle-question"></i>
                        </span>
                        <div class="input-group  w-200px">
                          <input type="number" class="form-control" #tireSize name="tireSize" [placeholder]="userPreferences?.lengthUnits.display" [(ngModel)]="carTrackSettings.tireSize" [required]="true" />
                          <div class="input-group-text">{{userPreferences?.lengthUnits?.display}}</div>
                          <button class="btn btn-secondary" type="button" (click)="showTireCalculatorModal()"><i class="fa-solid fa-calculator"></i></button>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row mb-1">
                      <div class="col-12">
                        <label for="frontTires" class="form-label">Front</label>
                        <select class="form-select  w-200px" id="frontTires" name="frontTires" [(ngModel)]="carTrackSettings.frontTires">
                          <option value="-4">Comfort: Hard</option>
                          <option value="-3">Comfort: Medium</option>
                          <option value="-2">Comfort: Soft</option>
                          <option value="-1">Sport: Hard</option>
                          <option value="0">Sport: Medium</option>
                          <option value="1">Sport: Soft</option>
                          <option value="2">Racing: Hard</option>
                          <option value="3">Racing: Medium</option>
                          <option value="4">Racing: Soft</option>

                        </select>
                      </div>
                    </div>

                    <div class="form-group row mb-1">
                      <div class="col-12">
                        <label for="rearTires" class="form-label">Rear</label>
                        <select class="form-select  w-200px" id="rearTires" name="rearTires" [(ngModel)]="carTrackSettings.rearTires">
                          <option value="-4">Comfort: Hard</option>
                          <option value="-3">Comfort: Medium</option>
                          <option value="-2">Comfort: Soft</option>
                          <option value="-1">Sport: Hard</option>
                          <option value="0">Sport: Medium</option>
                          <option value="1">Sport: Soft</option>
                          <option value="2">Racing: Hard</option>
                          <option value="3">Racing: Medium</option>
                          <option value="4">Racing: Soft</option>

                        </select>
                      </div>
                    </div>

                  </div>
                </div>
              </form>

              <div class="floating-action-bottom-right">
                <div ngbDropdown placement="top-end" #actionMenu1="ngbDropdown" class="d-inline">
                  <button class="btn btn-secondary mb-3 me-2 btn-round-icon" type="button" aria-expanded="false" ngbDropdownToggle>
                    <i class="fa-solid fa-angle-up"></i>
                  </button>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="save()"><i class="fa-solid fa-file-arrow-up me-2"></i>Save</button>
                    <hr class="dropdown-divider">
                    <button ngbDropdownItem (click)="save(true)"><i class="fa-solid fa-file-pen me-2"></i>Save As</button>
                    <hr class="dropdown-divider">
                    <button ngbDropdownItem (click)="load()"><i class="fa-solid fa-file-arrow-down me-2"></i>Load</button>
                    <hr class="dropdown-divider">
                    <button ngbDropdownItem (click)="new()"><i class="fa-solid fa-file-circle-plus me-2"></i>New</button>

                  </div>
                </div>
                <div class="d-inline">
                  <button class="btn btn-secondary mb-3 btn-round-text race-engineer-button" type="button" aria-expanded="false" (click)="toggleChat()">
                    GT7 Race Engineer
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>



        <div class="tab-pane fade" [ngClass]="{show: activeTab == 'suspension', active: activeTab == 'suspension'}" id="suspension-tab-pane" role="tabpanel" aria-labelledby="suspension-tab" tabindex="0">
          <h2>
            Suspension Settings
          </h2>
          <form #suspensionSettingsForm="ngForm" (ngSubmit)="calculateSuspension()">

            <div class="row">

              <!--Input Column 1-->
              <div class="col-md-6 col-lg-4" [hidden]="!showSuspensionSettings">

                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Base Performance</div>
                  <div class="col"><hr /></div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': suspensionSettingsFormControl.weightDistributionPercent?.errors && suspensionSettingsFormControl.weightDistributionPercent?.touched}">
                  <div class="col">
                    <label for="frontRearWeightBalance" class="form-label">Front-Rear Weight Balance</label>
                    <div class="input-group  w-200px">
                      <input type="number" class="form-control " id="weightDistributionPercent" name="weightDistributionPercent" placeholder="front %" [(ngModel)]="suspensionSettings.weightDistributionPercent" [required]="true">
                      <div class="input-group-text">%</div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Stability</div>
                  <div class="col"><hr /></div>
                </div>


                <div class="form-group row mb-3" [ngClass]="{'invalid': suspensionSettingsFormControl.lowSpeedStability?.errors && suspensionSettingsFormControl.lowSpeedStability?.touched}">
                  <div class="col">
                    <label for="lowSpeedStability" class="form-label">Low Speed</label>
                    <input type="text" pattern="\-?[0-9]*[\.,]?[0-9]*" class="form-control   w-120px" id="lowSpeedStability" name="lowSpeedStability" placeholder="(under)" [(ngModel)]="suspensionSettings.lowSpeedStability" [required]="true">
                  </div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': suspensionSettingsFormControl.highSpeedStability?.errors && suspensionSettingsFormControl.highSpeedStability?.touched}">
                  <div class="col">
                    <label for="highSpeedStability" class="form-label">High Speed</label>
                    <input type="text" pattern="\-?[0-9]*[\.,]?[0-9]*" class="form-control   w-120px" id="highSpeedStability" name="highSpeedStability" placeholder="(under)" [(ngModel)]="suspensionSettings.highSpeedStability" [required]="true">
                  </div>
                </div>

                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Rotational G</div>
                  <div class="col"><hr /></div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': suspensionSettingsFormControl.rotationalG1?.errors && suspensionSettingsFormControl.rotationalG1?.touched}">
                  <div class="col">
                    <label for="rotationalG1" class="form-label">G 40mph</label>
                    <div class="input-group  w-200px">
                      <input type="number" class="form-control " id="rotationalG1" name="rotationalG1" placeholder="G" [(ngModel)]="suspensionSettings.rotationalG1" [required]="true">
                      <div class="input-group-text">G</div>
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': suspensionSettingsFormControl.rotationalG2?.errors && suspensionSettingsFormControl.rotationalG2?.touched}">
                  <div class="col">
                    <label for="rotationalG2" class="form-label">75 mph</label>
                    <div class="input-group  w-200px">
                      <input type="number" class="form-control " id="rotationalG2" name="rotationalG2" placeholder="G" [(ngModel)]="suspensionSettings.rotationalG2" [required]="true">
                      <div class="input-group-text">G</div>
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': suspensionSettingsFormControl.rotationalG3?.errors && suspensionSettingsFormControl.rotationalG3?.touched}">
                  <div class="col-6">
                    <label for="rotaionalG3" class="form-label">150 mph</label>

                    <div class="input-group  w-200px">
                      <input type="number" class="form-control " id="rotationalG3" name="rotationalG3" placeholder="G" [(ngModel)]="suspensionSettings.rotationalG3" [required]="true">
                      <div class="input-group-text">G</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Suspension</div>
                  <div class="col"><hr /></div>
                </div>


                <div class="form-group row mb-1">
                  <div class="col-12">
                    <label for="bodyHeight" class="form-label">Body Height Adjustment</label>
                    <div class="row">
                      <div class="w-120px text-center" [ngClass]="{'text-invalid': suspensionSettingsFormControl.rideHeightFront?.errors && suspensionSettingsFormControl.rideHeightFront?.touched}">
                        Front
                      </div>
                      <div class="w-120px text-center" [ngClass]="{'text-invalid': suspensionSettingsFormControl.rideHeightRear?.errors && suspensionSettingsFormControl.rideHeightRear?.touched}">
                        Rear
                      </div>
                    </div>
                    <div class="row">
                      <div class="w-120px">
                        <input type="number" class="form-control " id="rideHeightFront" name="rideHeightFront" placeholder="mm" min="0"
                               [(ngModel)]="suspensionSettings.rideHeightFront"
                               [required]="true"
                               [ngClass]="{'invalid': suspensionSettingsFormControl.rideHeightFront?.errors && suspensionSettingsFormControl.rideHeightFront?.touched}">
                      </div>
                      <div class="w-120px">
                        <input type="number" class="form-control " id="rideHeightRear" name="rideHeightRear" placeholder="mm" min="0"
                               [(ngModel)]="suspensionSettings.rideHeightRear"
                               [required]="true"
                               [ngClass]="{'invalid': suspensionSettingsFormControl.rideHeightRear?.errors && suspensionSettingsFormControl.rideHeightRear?.touched}">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="differential" class="form-label">Oversteer/Understeer</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['oversteerUndersteer'].title"
                          [ngbPopover]="helpText['oversteerUndersteer'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="oversteerUndersteer" [(model)]="suspensionSettings.oversteerUndersteer!" class="w-200px" [min]="-5" [max]="5"></app-input-spinner>
                  </div>
                </div>
              </div>
              <!--Input Column 2-->
              <div class="col-md-6 col-lg-4" [hidden]="!showSuspensionSettings">
                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Aerodynamics</div>
                  <div class="col"><hr /></div>
                </div>

                <div class="form-group row mb-1">
                  <div class="col">
                    <label for="downforce" class="form-label">Downforce</label>
                    <!--<div class="row">
                      <div class="w-120px text-center" [ngClass]="{'text-invalid': suspensionSettingsFormControl.downforceFront?.errors && suspensionSettingsFormControl.downforceFront?.touched}">
                        Front
                      </div>
                      <div class="w-150px text-center" [ngClass]="{'text-invalid': suspensionSettingsFormControl.downforceRear?.errors && suspensionSettingsFormControl.downforceRear?.touched}">
                        Rear
                      </div>
                    </div>-->
                    <div class="row">
                      <div class="w-120px form-group" [ngClass]="{'invalid': suspensionSettingsFormControl.downforceFront?.errors && suspensionSettingsFormControl.downforceFront?.touched}">
                        <label for="downforceFront" class="form-label d-block text-center">Front</label>
                        <input type="number" class="form-control " id="downforceFront" name="downforceFront" placeholder="Lv."
                               [(ngModel)]="suspensionSettings.downforceFront"
                               [required]="true">
                      </div>
                      <div class="w-190px form-group" [ngClass]="{'invalid':  suspensionSettingsFormControl.downforceRear?.errors && suspensionSettingsFormControl.downforceRear?.touched}">
                        <label for="downforceRear" class="form-label d-block text-center w-120px">Rear</label>
                        <div class="input-group">
                          <input type="number" class="form-control " id="downforceRear" name="downforceRear" placeholder="Lv."
                                 [(ngModel)]="suspensionSettings.downforceRear"
                                 [disabled]="suspensionSettings.calculateRearDownforce"
                                 [required]="!suspensionSettings.calculateRearDownforce">
                          <span class="input-group-text" ngbTooltip="Calculate rear downforce." container="body">
                            <i class="fa-solid fa-calculator" style="margin-top:.25em; margin-right: .5em"></i>
                            <input class="form-check-input" type="checkbox" id="calculateRearDownforce" name="calculateRearDownforce"
                                   [(ngModel)]="suspensionSettings.calculateRearDownforce">

                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Race/Track Parameters</div>
                  <div class="col"><hr /></div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="springStiffness" class="form-label">Spring Stiffness</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['springStiffness'].title"
                          [ngbPopover]="helpText['springStiffness'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="springStiffness" [(model)]="suspensionSettings.springStiffness!" class="w-200px" [min]="-5" [max]="10"></app-input-spinner>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="arbStiffness" class="form-label">ARB Stiffness</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['arbStiffness'].title"
                          [ngbPopover]="helpText['arbStiffness'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="arbStiffness" [(model)]="suspensionSettings.arbStiffness!" class="w-200px" [min]="-4" [max]="10"></app-input-spinner>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="tireWear" class="form-label">Tire Wear</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['tireWear'].title"
                          [ngbPopover]="helpText['tireWear'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <select class="form-select  w-200px" id="tireWear" name="tireWear" [(ngModel)]="suspensionSettings.tireWear">
                      <option *ngFor="let i of numSequence(1,50)" value="{{i}}">{{i}}x</option>
                    </select>
                  </div>
                </div>


                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Other Adjustments</div>
                  <div class="col"><hr /></div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="reduceCornerEntryUndersteerOversteer" class="form-label">Reduce Corner Entry Understeer/Oversteer</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['cornerEntry'].title"
                          [ngbPopover]="helpText['cornerEntry'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="reduceCornerEntryUndersteerOversteer" [(model)]="suspensionSettings.reduceCornerEntryUndersteerOversteer!" class="w-200px" [min]="-4" [max]="4"></app-input-spinner>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="reduceCornerExitUndersteerOversteer" class="form-label">Reduce Corner Exit Understeer/Oversteer</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['cornerExit'].title"
                          [ngbPopover]="helpText['cornerExit'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="reduceCornerExitUndersteerOversteer" [(model)]="suspensionSettings.reduceCornerExitUndersteerOversteer!" class="w-200px" [min]="-4" [max]="4"></app-input-spinner>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="offsetSpringFrequency" class="form-label">Offset Spring Frequency</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['offsetSpringFrequency'].title"
                          [ngbPopover]="helpText['offsetSpringFrequency'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="offsetSpringFrequency" [(model)]="suspensionSettings.offsetSpringFrequency!" class="w-200px" [min]="-5" [max]="5"></app-input-spinner>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4">

                <div class="row m-0">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Suspension Settings</div>
                  <div class="col"><hr /></div>
                </div>


                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Front</th>
                      <th>Rear</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        Anti-Roll Bar
                      </th>
                      <td>
                        {{suspension?.antiRollBarFront}}
                      </td>
                      <td>
                        {{suspension?.antiRollBarRear}}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Damper Compression
                      </th>
                      <td>
                        {{suspension?.damperCompressionFront}}
                      </td>
                      <td>
                        {{suspension?.damperCompressionRear}}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Damper Extension
                      </th>
                      <td>
                        {{suspension?.damperExtensionFront}}
                      </td>
                      <td>
                        {{suspension?.damperExtensionRear}}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Spring Rate
                      </th>
                      <td>
                        {{suspension?.springRateFront}}
                      </td>
                      <td>
                        {{suspension?.springRateRear}}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Camber Angle
                      </th>
                      <td>
                        {{suspension?.camberAngleFront}}
                      </td>
                      <td>
                        {{suspension?.camberAngleRear}}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Toe Angle
                      </th>
                      <td>
                        {{suspension?.toeAngleFront}}
                      </td>
                      <td>
                        {{suspension?.toeAngleRear}}
                      </td>
                    </tr>
                    @if(suspensionSettings.calculateRearDownforce == true){
                    <tr>
                      <th scope="row">Downforce</th>
                      <td></td>
                      <td>{{suspensionSettings.downforceRear}}</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
            <div class="floating-action-bottom-right">
              <div class="d-inline">
                <button class="btn btn-success mb-3 me-2 btn-round-icon" type="submit"
                        [disabled]="suspensionLoading || suspensionSettingsForm.invalid || carTrackSettingsForm.invalid || !carTrackSettings.vehicle || !carTrackSettings.track"
                        aria-expanded="false">
                  <i class="fa-solid" [class]="{'fa-calculator': !suspensionLoading, 'fa-spinner': suspensionLoading, 'fa-spin': suspensionLoading }"></i>
                </button>
              </div>

              <div ngbDropdown placement="top-end" #actionMenu2="ngbDropdown" class="d-inline">
                <button class="btn btn-secondary mb-3 me-2 btn-round-icon" type="button" aria-expanded="false" ngbDropdownToggle>
                  <i class="fa-solid fa-angle-up"></i>
                </button>
                <div ngbDropdownMenu>
                  <button type="button" ngbDropdownItem (click)="save()"><i class="fa-solid fa-file-arrow-up me-2"></i>Save</button>
                  <hr class="dropdown-divider">
                  <button type="button" ngbDropdownItem (click)="save(true)"><i class="fa-solid fa-file-pen me-2"></i>Save As</button>
                  <hr class="dropdown-divider">
                  <button type="button" ngbDropdownItem (click)="load()"><i class="fa-solid fa-file-arrow-down me-2"></i>Load</button>
                  <hr class="dropdown-divider">
                  <button type="button" ngbDropdownItem (click)="new()"><i class="fa-solid fa-file-circle-plus me-2"></i>New</button>

                </div>
              </div>
              <div class="d-inline">
                <button class="btn btn-secondary mb-3 btn-round-text race-engineer-button" type="button" aria-expanded="false" (click)="toggleChat()">
                  GT7 Race Engineer
                </button>
              </div>
            </div>
          </form>



        </div>


        <div class="tab-pane fade" [ngClass]="{show: activeTab == 'transmission', active: activeTab == 'transmission'}" id="transmission-tab-pane" role="tabpanel" aria-labelledby="transmission-tab" tabindex="0">
          <h2>
            Transmission Settings
          </h2>
          <form #transmissionSettingsForm="ngForm" (ngSubmit)="calculateDrivetrain()">
            <div class="row">
              <!--drivetrain Settings-->
              <div class="col-md-6 col-lg-4" [hidden]="!showDrivetrainSettings">
                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Base Performance</div>
                  <div class="col"><hr /></div>
                </div>


                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.maxPower?.errors && drivetrainSettingsFormControl.maxPower?.touched}">
                  <div class="col">
                    <label for="maxPower" class="form-label">Max Power</label>
                    <div class="input-group  w-200px">
                      <input type="number" class="form-control " id="maxPower" name="maxPower" [placeholder]="userPreferences?.powerUnits.display" [(ngModel)]="drivetrainSettings.maxPower" [required]="true">
                      <span class="input-group-text">{{userPreferences?.powerUnits.display}}</span>
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.minRPM?.errors && drivetrainSettingsFormControl.minRPM?.touched}">
                  <div class="col">
                    <label for="minRPM" class="form-label">Min RPM</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['minRPM'].title"
                          [ngbPopover]="helpText['minRPM'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <input type="number" class="form-control  w-120px" id="minRPM" name="minRPM" placeholder="RPM" [(ngModel)]="drivetrainSettings.minRPM" [required]="true">
                  </div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.maxRPM?.errors && drivetrainSettingsFormControl.maxRPM?.touched}">
                  <div class="col">
                    <label for="maxRPM" class="form-label">Max RPM</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['maxRPM'].title"
                          [ngbPopover]="helpText['maxRPM'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <input type="number" class="form-control  w-120px" id="maxRPM" name="maxRPM" placeholder="RPM" [(ngModel)]="drivetrainSettings.maxRPM" [required]="true">
                  </div>
                </div>

                @if(subscription.subscriptionLevel == SubscriptionLevels.Lite){
                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="ratioAdjuster" class="form-label">Gear Ratio Adjuster</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['ratioAdjuster'].title"
                          [ngbPopover]="helpText['ratioAdjuster'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <select class="form-select  w-200px" id="ratioAdjuster" name="ratioAdjuster" [(ngModel)]="drivetrainSettings.ratioAdjuster">
                      <option *ngFor="let i of numSequence(60,90, 2)" value="{{i}}">{{i}}%</option>
                    </select>
                  </div>
                </div>
                }

                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.maxPowerRPM?.errors && drivetrainSettingsFormControl.maxPowerRPM?.touched}">
                  <div class="col">
                    <label for="maxPowerRPM" class="form-label">RPM &#64; Max Power</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['maxPowerRPM'].title"
                          [ngbPopover]="helpText['maxPowerRPM'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <input type="number" class="form-control  w-120px" id="maxPowerRPM" name="maxPowerRPM" placeholder="RPM" [(ngModel)]="drivetrainSettings.maxPowerRPM" [required]="true">
                  </div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.maxTorque?.errors && drivetrainSettingsFormControl.maxTorque?.touched}">
                  <div class="col">
                    <label for="maxTorque" class="form-label">Max Torque</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['maxTorque'].title"
                          [ngbPopover]="helpText['maxTorque'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <div class="input-group  w-200px">
                      <input type="number" class="form-control " id="maxTorque" name="maxTorque" [placeholder]="userPreferences?.torqueUnits.display" [(ngModel)]="drivetrainSettings.maxTorque" [required]="true">
                      <div class="input-group-text">{{userPreferences?.torqueUnits.display}}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Differential Gear</div>
                  <div class="col"><hr /></div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="differential" class="form-label">LSD Setting</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['lsdSettings'].title"
                          [ngbPopover]="helpText['lsdSettings'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="lsdSetting" [(model)]="drivetrainSettings.lsdSetting!" class="w-200px" [min]="-5" [max]="5"></app-input-spinner>
                  </div>
                </div>

                @if (carTrackSettings.vehicle?.driveType == 'FWD'){
                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="torqueDistribution" class="form-label">Front Torque Distribution</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['torqueDistribution'].title"
                          [ngbPopover]="helpText['torqueDistribution'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <app-input-spinner name="torqueDistribution" [(model)]="drivetrainSettings.torqueDistribution!" class="w-200px" [min]="0" [max]="50" [step]="5"></app-input-spinner>
                  </div>
                </div>
                }

              </div>
              <div class="col-md-6 col-lg-4" [hidden]="!showDrivetrainSettings">

                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Gears</div>
                  <div class="col"><hr /></div>
                </div>

                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.topSpeed?.errors && drivetrainSettingsFormControl.topSpeed?.touched}">
                  <div class="col">
                    <label for="topSpeed" class="form-label">Top Speed</label>
                    <div class="input-group w-170px">
                      <input type="number" class="form-control" id="topSpeed" name="topSpeed" [placeholder]="userPreferences?.speedUnits.display" [(ngModel)]="drivetrainSettings.topSpeed" [required]="true">
                      <div class="input-group-text">{{userPreferences?.speedUnits.display}}</div>
                    </div>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="gearCount" class="form-label">Number of Gears</label>
                    <select class="form-select  w-120px" id="gearCount" name="gearCount" [(ngModel)]="drivetrainSettings.gearCount">
                      <option *ngFor="let i of numSequence(3,9)" [ngValue]="i">{{i}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="finalGear" class="form-label">Final Gear</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['finalGearCalc'].title"
                          [ngbPopover]="helpText['finalGearCalc'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <select class="form-select  w-200px" id="finalGearOption" name="finalGearOption" [(ngModel)]="drivetrainSettings.finalGearOption">
                      <option [ngValue]="'calc'">Calculate</option>
                      <option [ngValue]="'user'">User Input</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row mb-3" *ngIf="drivetrainSettings.finalGearOption=='user'">
                  <div class="col">
                    <label for="finalGear" class="form-label">Final Gear Ratio</label>
                    <input type="number" class="form-control w-120px" id="finalGear" name="finalGear" [(ngModel)]="drivetrainSettings.finalGear" />
                  </div>
                </div>

                @if(subscription.subscriptionLevel == 'Advanced' || subscription.subscriptionLevel == 'Trial'){
                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="gearRatios" class="form-label">Gear Ratios</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['gearRatiosCalc'].title"
                          [ngbPopover]="helpText['gearRatiosCalc'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <select class="form-select  w-200px" id="gearRatiosOption" name="gearRatiosOption"
                            [(ngModel)]="drivetrainSettings.gearRatiosOption">
                      <option value="calc">Calculate</option>
                      <option value="user">User Input</option>
                    </select>
                  </div>
                </div>
                }

                <div *ngIf="drivetrainSettings.gearRatiosOption=='user'">
                  <div class="row">
                    <div class="w-200px text-center">
                      <strong>Gear No.</strong>
                    </div>
                    <div class="w-200px text-center">
                      <strong>Ratio</strong>
                    </div>
                  </div>
                  <div class="row" *ngFor="let i of numSequence(1, drivetrainSettings.gearCount)">
                    <div class="w-200px text-center">
                      {{i}}
                    </div>
                    <div class="w-200px text-center">
                      <input type="number" class="form-control w-120px mx-auto"
                             [id]="'gear'+i"
                             [name]="'gear'+i"
                             [(ngModel)]="drivetrainSettings.gearRatios[i]"
                             [required]="drivetrainSettings.gearRatiosOption=='user'" />
                    </div>
                  </div>
                </div>

                <!--@if(subscription.subscriptionLevel == 'Advanced' || subscription.subscriptionLevel == 'Trial'){
                <div class="form-group row mb-3">
                  <div class="col">
                    <label for="screenshotSelector" class="form-label">Torque Graph <small>(screenshot with auto-detection)</small></label>
                    <span class="pointer help-popper" (click)="showScreenshotHelpModal()">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <div tabindex="0">
                      <button type="button" class="btn me-2"
                              [ngbTooltip]="screenshotFilename || 'Select a screenshot'"
                              [class]="{'btn-success': screenshotFile!=null || (drivetrainSettings.engineData && drivetrainSettings.engineData.length>1), 'btn-light':screenshotFile==null && (!drivetrainSettings.engineData || drivetrainSettings.engineData.length==0)}" id="selectScreenshot"
                              (click)="screenshotSelector.click()"
                              [disabled]="screenshotFile!=null || (drivetrainSettings.engineData && drivetrainSettings.engineData.length>1)">
                        <i class="fa-regular fa-solid" [class]="{'fa-check': screenshotFile!=null || (drivetrainSettings.engineData && drivetrainSettings.engineData.length>1), 'fa-image': screenshotFile==null && (!drivetrainSettings.engineData || drivetrainSettings.engineData.length==0)}"></i>
                      </button>

                      <button type="button" class="btn btn-danger " id="clearScreenshot" (click)="clearScreenshotSelector()" appBsTooltip title="Clear selected torque curve data" [disabled]="screenshotFile==null && (drivetrainSettings.engineData && drivetrainSettings.engineData.length==0)">
                        <i class="fa-solid fa-times"></i>
                      </button>
                    </div>
                    <input type="file" class="form-control" name="screenshot" (change)="fileChanged($event)" #screenshotSelector accept="image/png, image/jpeg" hidden />
                  </div>
                </div>

                }-->
                @if(subscription.subscriptionLevel == 'Advanced' || subscription.subscriptionLevel == 'Trial'){
                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.minCornerSpeed?.errors && drivetrainSettingsFormControl.minCornerSpeed?.touched}">
                  <div class="col">
                    <label for="minCornerSpeed" class="form-label">Min Corner Speed</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['minCornerSpeed'].title"
                          [ngbPopover]="helpText['minCornerSpeed'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <div class="input-group w-170px">
                      <input type="number" class="form-control" id="minCornerSpeed" name="minCornerSpeed" [placeholder]="userPreferences?.speedUnits.display" [(ngModel)]="drivetrainSettings.minCornerSpeed" [required]="true">
                      <div class="input-group-text">{{userPreferences?.speedUnits.display}}</div>
                    </div>
                  </div>
                </div>


                <div class="form-group row mb-3" [ngClass]="{'invalid': drivetrainSettingsFormControl.minCornerSpeedGear?.errors && drivetrainSettingsFormControl.minCornerSpeedGear?.touched}">
                  <div class="col">
                    <label for="minCornerSpeedGear" class="form-label">Min Corner Speed Gear</label>
                    <span class="pointer help-popper"
                          [popoverTitle]="helpText['minCornerSpeedGear'].title"
                          [ngbPopover]="helpText['minCornerSpeedGear'].text">
                      <i class="fa-solid fa-circle-question"></i>
                    </span>
                    <input type="number" class="form-control  w-120px" id="minCornerSpeedGear" name="minCornerSpeedGear" placeholder="" [(ngModel)]="drivetrainSettings.minCornerSpeedGear" [required]="true">
                  </div>
                </div>



                <div class="row">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Engine Data</div>
                  <div class="col"><hr /></div>
                </div>

                @if(drivetrainSettings.engineData && drivetrainSettings.engineData.length > 0){
                <button type="button" class="btn btn-danger btn-sm mb-3" (click)="clearEngineData()"><i class="fa-regular fa-solid fa-times"></i> Clear Data</button>
                <div ngbAccordion>
                  <div ngbAccordionItem [collapsed]="true">
                    <h2 ngbAccordionHeader>
                      <button ngbAccordionButton>RPM/Torque/Power</button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th>RPM</th>
                                <th>Torque</th>
                                <th>Power</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let ed of drivetrainSettings.engineData">
                                <td>{{ed.rpm}}</td>
                                <td>{{ed.torque | lbftToTorque: userPreferences.torqueUnits}}</td>
                                <td>{{ed.power | hpToPower: userPreferences.powerUnits }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>

                }
                @else{
                <p>Use Analyze Image to extract dyno graph from GT7 screenshot.</p>
                }
                }
              </div>

              <!--End drivetrain Settings-->
              <!--drivetrain results-->
              <div class="col-12 col-lg-4">
                <div class="row m-0">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Gear Ratio Settings</div>
                  <div class="col"><hr /></div>
                </div>


                <table class="table">
                  <thead>
                    <tr>
                      <th>Gear</th>
                      <th>Ratio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let gear of gearsToArray()">
                      <th scope="row">
                        {{gear.gearNumber}}
                      </th>

                      <td>
                        {{gear.gearRatio | number : '0.3-3'}}
                      </td>
                    </tr>
                    <tr>
                      <th>Final</th>
                      <td>{{drivetrain?.finalGear | number : '0.3-3'}}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="row m-0">
                  <div class="col"><hr /></div>
                  <div class="col-auto">Differential</div>
                  <div class="col"><hr /></div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Front</th>
                      <th>Rear</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        Initial Torque
                      </th>
                      <td>
                        {{ showFrontDifferential() ? drivetrain.initialTorqueFront : '' }}
                      </td>
                      <td>
                        {{ showRearDifferential() ? drivetrain.initialTorqueRear : '' }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Acceleration
                      </th>
                      <td>
                        {{ showFrontDifferential() ? drivetrain.accelerationFront : '' }}
                      </td>
                      <td>
                        {{ showRearDifferential() ? drivetrain.accelerationRear : '' }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Decceleration
                      </th>
                      <td>
                        {{ showFrontDifferential() ? drivetrain.decelerationFront : '' }}
                      </td>
                      <td>
                        {{ showRearDifferential() ? drivetrain.decelerationRear : '' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  @if(subscription.subscriptionLevel == 'Advanced' || subscription.subscriptionLevel == 'Trial'){
                  <div class="col-12 mb-3 h-300px" [hidden]="!dynoChartConfig">
                    <canvas #dynoChart class="bg-light" appChartJs chartId="dynoChart" [chartConfig]="dynoChartConfig"></canvas>
                  </div>
                  }
                  <div class="col-12 mb-3 h-300px" [hidden]="!shiftPointsChartConfig">
                    <canvas #shiftPointsChart class="bg-light" appChartJs [chartConfig]="shiftPointsChartConfig"></canvas>
                  </div>
                  @if(subscription.subscriptionLevel == 'Advanced' || subscription.subscriptionLevel == 'Trial'){
                  <div class="col-12 mb-3 h-300px" [hidden]="!tractiveForceChartConfig">
                    <canvas #tractiveForce class="bg-light" appChartJs chartId="tractiveForce" [chartConfig]="tractiveForceChartConfig"></canvas>
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="floating-action-bottom-right">
              <div class="d-inline">
                <button class="btn btn-success mb-3 me-2 btn-round-icon" type="submit"
                        [disabled]="drivetrainLoading || transmissionSettingsForm.invalid || carTrackSettingsForm.invalid || !carTrackSettings.vehicle || !carTrackSettings.track"
                        aria-expanded="false">
                  <i class="fa-solid" [class]="{'fa-calculator': !drivetrainLoading, 'fa-spinner': drivetrainLoading, 'fa-spin': drivetrainLoading }"></i>
                </button>
              </div>
              <div ngbDropdown placement="top-end" #actionMenu3="ngbDropdown" class="d-inline">
                <button class="btn btn-secondary mb-3 me-2 btn-round-icon" type="button" aria-expanded="false" ngbDropdownToggle>
                  <i class="fa-solid fa-angle-up"></i>
                </button>
                <div ngbDropdownMenu>
                  <button type="button" ngbDropdownItem (click)="save()"><i class="fa-solid fa-file-arrow-up me-2"></i>Save</button>
                  <hr class="dropdown-divider">
                  <button type="button" ngbDropdownItem (click)="save(true)"><i class="fa-solid fa-file-pen me-2"></i>Save As</button>
                  <hr class="dropdown-divider">
                  <button type="button" ngbDropdownItem (click)="load()"><i class="fa-solid fa-file-arrow-down me-2"></i>Load</button>
                  <hr class="dropdown-divider">
                  <button type="button" ngbDropdownItem (click)="new()"><i class="fa-solid fa-file-cirlcle-plus me-2"></i>New</button>

                </div>
              </div>
              <div class="d-inline">
                <button class="btn btn-secondary mb-3 btn-round-text race-engineer-button" type="button" aria-expanded="false" (click)="toggleChat()">
                  GT7 Race Engineer
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>



  </div>
</div>

<!-- GT7 Race Engineer Chat Widget -->
<app-gt7-chat-widget [carTrackSettings]="carTrackSettings"
                     [suspensionSettings]="suspensionSettings"
                     [drivetrainSettings]="drivetrainSettings"
                     [suspension]="suspension"
                     [drivetrain]="drivetrain"
                     [savedSettingsName]="savedSettingsName"
                     [(isExpanded)]="gt7ChatWidgetExpanded"
                     [isSubscribed]="!isAIEngineerSubscriptionExpired"></app-gt7-chat-widget>


